import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtils';

import { intelyStorageDefaultStates } from '../../hooks/useMyFilesHook';

const intelyStorageActions = mapDefaultValuesToActions(intelyStorageDefaultStates);

export default reduxReducerHelper(intelyStorageActions, intelyStorageDefaultStates);
